import React, { useMemo } from "react";
import { getVariantLabel, simulateClick } from "@leafly-com/web-utils";
import classnames from "classnames";

import currencyFormatter, { centsToDollars } from "@/utils/currencyFormatter";
import fullVariantSizeText from "@/utils/getFullVariantSizeText";

import { VariantTile } from "@/components/Dispensary/VariantTile";

type VariantSelectProps = {
  allowSelections?: boolean;
  countryCode: string;
  className?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  variantSelected: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  variants: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  selectVariant: (variant: any) => void;
  inStoreCart?: boolean;
};

const VariantSelect = ({
  allowSelections = true,
  variantSelected,
  variants,
  selectVariant,
  inStoreCart,
  countryCode,
  className,
}: VariantSelectProps) => {
  // Sort first by deal, then by price
  const sortedVariants = useMemo(
    () =>
      variants.slice().sort(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
        (a: any, b: any) =>
          // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
          (!!b.deal?.active as any) - (!!a.deal?.active as any) ||
          a.price - b.price,
      ),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    [variants.map((v: any) => v.id).toString()],
  );

  return (
    <>
      <div
        data-testid="variant-select"
        className={classnames(
          {
            "row flex-nowrap md:flex-wrap items-stretch overflow-scroll md:overflow-auto -mb-sm":
              allowSelections,
          },
          className,
        )}
      >
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate */}
        {sortedVariants.map((variant: any) => {
          const { deal, price, id, unit, quantity } = variant;

          if (!allowSelections && !inStoreCart) {
            const displayPrice = deal?.active
              ? centsToDollars(deal.discountedPrice)
              : price;
            const displayUnit = fullVariantSizeText(
              getVariantLabel({
                packageSize: quantity,
                packageUnit: unit,
              }),
            );

            return (
              <div key={variant.id} data-testid="in-store-price">
                {displayUnit}&nbsp;&nbsp;–&nbsp;&nbsp;
                {currencyFormatter(displayPrice, countryCode)}
              </div>
            );
          }

          return (
            <div
              key={variant.id}
              className="flex-grow-0 col-auto md:col-1/2 lg:col-1/3 mb-sm"
            >
              <VariantTile
                countryCode={countryCode}
                onClick={() => selectVariant(variant)}
                onKeyDown={simulateClick}
                role="button"
                aria-label={`Select price of ${variant.price} for ${variant.quantity} ${variant.unit}`}
                selected={id === variantSelected.id}
                tabIndex={0}
                variant={variant}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default VariantSelect;
